import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'
import * as codeActions from 'client/bookmate/reducers/code-reducer'
import Meta from 'client/shared/blocks/meta'
import MetaTitle from 'client/shared/blocks/meta-title'
import { MetaDescription } from 'client/shared/blocks/meta-description'
import Footer from 'client/shared/blocks/footer'
import Spacer from 'client/shared/blocks/spacer'
import { Dispatch, State } from 'shared/types/redux'
import { Location } from 'client/shared/types/react-router'
import { CurrentUserState } from 'client/shared/types/current-user'
import { State as CodeState } from 'client/bookmate/reducers/code-reducer'
import { TelcelLayout } from '../blocks/telcel-layout/telcel-layout'
import prepareComponent from 'client/shared/decorators/prepare-component'

type Props = {
  location: Location
  code: CodeState
  dispatch: Dispatch
  currentUser: CurrentUserState
  isDesktopAllSizes(): boolean
  campaign?: string
} & DecoratorProps

export const TELCEL = 'Telcel'
export const THREE_MES = 'threemes'

class TelcelPage extends Component<Props> {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps: Props): void {
    const {
      auth,
      dispatch,
      code: { codeValue },
      location,
    } = this.props

    if (auth && !prevProps.auth && codeValue) {
      dispatch(codeActions.checkCode({ codeValue, query: location.search }))
    }
  }

  handleInput = (e: React.SyntheticEvent<HTMLInputElement>): void => {
    const { dispatch } = this.props

    dispatch(
      codeActions.setCode({
        codeValue: e.target.value,
        autocomplete: false,
      }),
    )
  }

  handleForm = (e: React.SyntheticEvent<HTMLFormElement>): void => {
    const {
      currentUser: { auth },
      code: { codeValue },
      dispatch,
      location,
    } = this.props

    e.preventDefault()

    if (auth)
      dispatch(codeActions.checkCode({ codeValue, query: location.search }))
  }

  render(): JSX.Element {
    const {
      isDesktopAllSizes,
      isTabletSize,
      currentUser: { auth, data },
      code,
      campaign,
    } = this.props

    const isDesktop = isDesktopAllSizes() || isTabletSize()
    const isThreeMes = campaign === THREE_MES

    const title = 'La mejor oferta en Bookmate'
    const description =
      'Aprovecha 3 meses de suscripción a Bookmate por 99MXN. Descubre millones de libros, audiolibros y cómics. ¡Empieza a leer!'

    return (
      <Fragment>
        <MetaTitle title={title} og={title} />
        <MetaDescription description={description} og={description} />
        <Meta
          content={
            isThreeMes
              ? 'https://a.bmstatic.com/iu/20/39/Sharing pic Twitter-42facd69ec6804f8d28ef625f8a6743d.png'
              : 'https://a.bmstatic.com/iu/52/99/tw-telcel (1)-5267744f0295c0609db828296c39a414.png'
          }
          property="twitter:image"
        />
        <Meta
          content={
            isThreeMes
              ? 'https://a.bmstatic.com/iu/49/239/Sharing pic FB-4cf239b14fd297ec0bed21a281c20153.png'
              : 'https://a.bmstatic.com/iu/219/11/fb-telcel (1)-65e8e286507ac17ee09aa60a5270e1cd.png'
          }
          property="og:image"
        />
        <TelcelLayout
          code={code}
          locale={data.locale}
          auth={auth}
          handleForm={this.handleForm}
          handleInput={this.handleInput}
          isDesktop={isDesktop}
          campaign={campaign}
        />
        <Spacer size={isDesktop ? 64 : 32} />
        <Footer />
      </Fragment>
    )
  }
}

const prepareWrapper = prepareComponent(async function ({ store, location }) {
  const { dispatch } = store
  const { query, pathname } = location
  let { code: codeValue } = query
  if (pathname.includes('3mesesx99')) codeValue = '3MESES'
  if (codeValue) {
    dispatch(
      codeActions.setCode({
        codeValue,
      }),
    )
  }
})

const connectWrapper = connect((state: State) => ({
  currentUser: state.currentUser,
  code: state.code,
}))

const wrappers = compose(prepareWrapper, connectWrapper, uiBox)

export default wrappers(TelcelPage)
